import AppModalContainer from '@nxsys/components/AppModalContainer';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import {
  PSRPayloadType,
  PSRResponseType,
} from '@nxsys/types/models/revenueFilings/psr';
import ReactJson from 'react-json-view';

type ViewJsonModalProps = {
  isOpen: boolean;
  toggle: () => void;
  data: PSRPayloadType | PSRResponseType;
};

export const ViewJsonModal = ({ isOpen, toggle, data }: ViewJsonModalProps) => {
  const { messages } = useTypedIntl();

  return (
    <AppModalContainer
      title={messages['common.view']}
      isOpen={isOpen}
      minHeight="200px"
      toggle={toggle}
      actions={[
        {
          name: messages['common.cancel'],
          buttonType: 'primary',
          variant: 'outlined',
          onClick: toggle,
        },
      ]}
    >
      <div className="h-[500px] overflow-y-auto">
        <ReactJson src={data} />
      </div>
    </AppModalContainer>
  );
};

export default ViewJsonModal;
